import { IPCRAction, IPCRState } from './pcr.types'
import { PCRConstants } from './pcr.constants'

export const initialPCRState: IPCRState = {
  userId: '',
  pcrId: '',
  pcrDocs: [],
  exception: null,
  error: null,
}

export function pcrDbReducer(state: IPCRState = initialPCRState, action: IPCRAction): IPCRState {
  switch (action.type) {
    case PCRConstants.CREATE_PCR:
      return { ...state, userId: action.userId }
    case PCRConstants.THROW_PCR_EXCEPTION:
      return { ...state, exception: action.exception }
    case PCRConstants.CRUD_PCR_EXCEPTION:
      return { ...state, exception: action.exception }
    case PCRConstants.RESET_PCR_ERROR:
      return { ...state, exception: null }
    case PCRConstants.LOG_ERROR_ACTION:
      return { ...state, error: action.error }
    default:
      return state
  }
}
